module.exports = __webpack_public_path__ + "static/media/wechat.6bf53c40.png";